import { buildGetStaticProps } from '../../tngPassthrough/tngPageHandler'

export { default } from '../../tngPassthrough/TngPage'
export { getStaticPaths } from '../../tngPassthrough/tngPageHandler'

export const getStaticProps = buildGetStaticProps('giftcards', 3600)
